import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50/10">
                <i className="ri-anchor-line text-xl text-background-50"></i>
              </div>
              <span className="font-heading font-semibold text-lg text-background-50 whitespace-nowrap">鲍鱼域名导航</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              安全访问，从正确域名开始。<br />官方域名入口导航平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">首页</Link></li>
              <li><Link to="/category/domain-entry" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">域名入口导航</Link></li>
              <li><Link to="/category/security-access" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">安全访问指南</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">服务支持</h4>
            <ul className="space-y-2.5">
              <li><Link to="/category/register-login" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">注册登录教程</Link></li>
              <li><Link to="/category/domain-protection" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">域名防丢失</Link></li>
              <li><Link to="/article/anti-phishing-security-guide" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">防钓鱼指南</Link></li>
              <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line"></i> support@baoyu-official.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-wechat-line"></i> 微信：baoyu-kefu
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-time-line"></i> 9:00 - 21:00
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">© 2026 鲍鱼域名导航. All rights reserved. ICP备XXXXXXXX号</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors" rel="nofollow">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}